import PtacExistingUnitsFields from 'components/existing-equipment-page/ptac-existing-units-fields';
import usePtacPreferences from 'hooks/use-ptac-preferences';
import { useEffect } from 'react';
import {
  EMPTY_PTAC_EXISTING_UNITS,
  withPtacExistingUnitsAnswer,
  withPtacReplacingAnswer
} from 'utils/ptac-preferences';

type PtacExistingUnitsCardProps = {
  systemUniqueId: string;
};

export default function PtacExistingUnitsCard({
  systemUniqueId
}: PtacExistingUnitsCardProps) {
  const { record, loaded, update } = usePtacPreferences(systemUniqueId);
  const replacingRecorded = record?.replacing === true;

  useEffect(() => {
    if (loaded && !replacingRecorded) {
      update(withPtacReplacingAnswer(record ?? {}, true));
    }
  }, [loaded, replacingRecorded, record, update]);

  if (!loaded) {
    return (
      <div className='mb-4 rounded-lg border border-gray-200 bg-gray-50 p-3 text-sm text-gray-500'>
        Loading existing PTAC details…
      </div>
    );
  }

  const current = record ?? {};

  return (
    <section
      aria-label='Existing PTAC units'
      className='flex flex-col gap-5 rounded-lg border border-gray-200 bg-white p-5'
    >
      <div>
        <h3 className='text-lg font-semibold text-gray-900'>
          Existing PTAC units
        </h3>
        <p className='text-sm text-gray-500'>
          What is in the wall today decides which accessories the replacement
          needs: a sound standard sleeve and grille can be reused, anything else
          gets replaced with the unit.
        </p>
      </div>
      <PtacExistingUnitsFields
        existing={current.existing ?? EMPTY_PTAC_EXISTING_UNITS}
        onChange={(patch) =>
          update(withPtacExistingUnitsAnswer(current, patch))
        }
      />
    </section>
  );
}
